import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import { buildUrl } from '../../helpers/links';
import { sanitizeSlug } from '../../helpers/sanitizeSlug';
import styles from './navigation.module.scss';
export const LiLevel0 = ({ children, navigationGroups })=>{
    const pathname = usePathname();
    const isActive = navigationGroups.some((group)=>group.items.some((item)=>sanitizeSlug(buildUrl(item.link) || '').startsWith(sanitizeSlug(pathname))));
    return /*#__PURE__*/ _jsx("li", {
        className: classNames(styles['nav-level-0-list-item'], isActive && styles['nav-level-0-list-item-active']),
        children: children
    });
};

//# sourceMappingURL=li-level-0.js.map